import { createTRPCReact } from "@trpc/react-query";
import type { ApiRouter } from "@repo/api/trpc/router";

export const api = createTRPCReact<ApiRouter>({});
